// Is this a mobile device? Passkeys/biometric sign-in are offered on mobile
// only — web keeps password + TOTP (the SOC-2 posture: strong MFA on desktop,
// passkey convenience on phones). UA-based with an iPadOS-13+ fallback (iPads
// report a desktop "Macintosh" UA but expose touch points).
export function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/Android|iPhone|iPod|iPad|Mobile|Silk|Kindle|BlackBerry|Opera Mini|IEMobile/i.test(ua)) {
    return true;
  }
  // iPadOS 13+ masquerades as macOS Safari — detect the touch capability.
  if (/Macintosh/i.test(ua) && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1) {
    return true;
  }
  return false;
}

export default isMobileDevice;
